import { Link } from 'react-router-dom';
import onlyMeLogo from '../img/onlymelogo.png';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { GoogleIcon, KakaoIcon } from '../components/ui/icons';

/**
 * 로그인 페이지
 *
 * @author hjkim
 * @constructor
 */
const Login = () => {
  /**
   * Handlers
   */
  /* 로그인 버튼 handler */
  const onSignInHandler = (provider: string) => {
    console.log('로그인 시도:', provider);
    const baseUrl = process.env.REACT_APP_API_URL;
    if (provider === 'kakao') {
      console.log('카카오 로그인 버튼 클릭');
      window.location.href = `${baseUrl}/oauth2/authorization/${provider}`;
    } else if (provider === 'google') {
      console.log('구글 로그인 버튼 클릭');
      window.location.href = `${baseUrl}/oauth2/authorization/google`;
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50/30 p-4">
      <div className="w-full max-w-md space-y-6">
        {/* 로고 및 타이틀 */}
        <div className="text-center space-y-3">
          <div className="w-32 h-32 bg-gradient-to-br from-green-50 to-green-200 rounded-2xl flex items-center justify-center mx-auto shadow-lg">
            <span className="w-20 h-28 text-2xl text-white">
              <img src={onlyMeLogo} alt="Logo /" />
            </span>
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">나만 그래?</h1>
            <p className="text-muted-foreground text-sm">소셜 로그인으로 간편하게 시작하세요.</p>
          </div>
        </div>
        {/* 소셜 로그인 폼 */}
        <Card className="border-0 shadow-xl">
          <CardHeader className="space-y-4 mb-4">
            <CardTitle className="text-xl text-center">로그인</CardTitle>
            <p className="text-sm text-muted-foreground text-center">소셜 계정으로 빠르고 안전하게 로그인하세요.</p>
          </CardHeader>
          <CardContent className="space-y-4">
            {/* 소셜 로그인 버튼 */}
            <div className="flex flex-col items-center space-y-3">
              <button
                type="button"
                onClick={() => onSignInHandler('kakao')}
                className="w-full h-14 bg-[#FEE500] hover:bg-[#FDD835] border border-[#FDD835] rounded-xl font-semibold text-black transition-all duration-200 flex items-center justify-center gap-3 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed">
                <KakaoIcon />
                <span>카카오 계정으로 계속하기</span>
              </button>
              <button
                type="button"
                onClick={() => onSignInHandler('google')}
                className="w-full h-14 bg-white hover:bg-gray-50 border border-gray-300 rounded-xl font-semibold text-black transition-all duration-200 flex items-center justify-center gap-3 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed">
                <GoogleIcon />
                <span>구글 계정으로 계속하기</span>
              </button>
            </div>
            {/* 설명 텍스트 */}
            <div className="text-center mt-6">
              <p className="text-xs text-muted-foreground leading-relaxed">
                소셜 로그인을 통해 간편하게 가입하고 로그인 할 수 있습니다.
                <br />
                개인정보는 안전하게 보호됩니다.
              </p>
            </div>
            {/* 약관 동의 */}
            <div className="text-center mt-4">
              <p className="text-xs">로그인 시 이용약관 및 개인정보처리방침에 동의한 것으로 간주됩니다.</p>
            </div>
          </CardContent>
        </Card>
        {/* 뒤로가기 */}
        <div className="text-center">
          <Link to="/" className="text-sm text-muted-foreground hover:text-fore-ground transition-colors duration">
            메인으로 돌아가기
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
